import React, { useEffect, useState } from "react";
import { notifyError } from "../../helper";
import { useParams } from "react-router-dom";
import client from "../../api";
import StepSummary from "./StepSummary";
import LeadSummary from "./LeadSummary";
import TotalSummary from "./TotalSummary";
import SummaryColumn from "./SummaryColumn";
import RepliesColumn from "./RepliesColumn";
import LeadColumn from "./LeadColumn";
import BlockLoader from "../BlockLoader";

const CampaignSummary = (props) => {
    const {contactList} = props;
    const {campaignID} = useParams('');
    const api = client();
    const [pageLoader,setPageLoader] = useState(false);
    const [overviewSummary, setOverviewSummary] = useState({});

    useEffect(()=>{
        const getOverviewSummary = async () => {
            try{
                setPageLoader(true);
                 
                const response = await api.post('/v1/campaign/overview/summary',{
                    campaign_id:campaignID,
                    list_id: contactList
                });
                if(response.status === 200 || response.status === 201){
                    setPageLoader(false);
                    const data = response.data;
                    //console.log('response data',data);
                    setOverviewSummary(data.campaignOverview);
                }
            } catch(error) {
                setPageLoader(false);
                console.log('error.messsage',error);
                if(error.status === 400) notifyError('Bad Rrequest. Unable to fetch Campaign Summary');
            }
        }
        getOverviewSummary();

    },[contactList]);
    
    return(<>
        {pageLoader ? <div className="campaign-summary-wrap bg-white"><BlockLoader/></div> : <div className="campaign-summary-wrap">
            {Object.keys(overviewSummary).length && <LeadSummary leadinfo={overviewSummary.leads_status_count_percentage} leadstotal={overviewSummary.total_leads_count} />}
        
            <div className="summary-blocks">
                <h2>Funnel</h2>
                {Object.keys(overviewSummary).length && (overviewSummary?.steps).map((step,i)=>(
                    <StepSummary 
                        step={step} 
                        key={i} 
                        index={i} 
                        messageType={props.messageType} 
                        trackOpen={props.trackOpen} 
                        trackClicks={props.trackClicks} 
                    />
                ))}
            </div>
            {Object.keys(overviewSummary).length && <>
                <TotalSummary 
                    totalinfo={overviewSummary.total_email_event_count_percentage} 
                    totalcontacts={overviewSummary.first_step_total_recipients} 
                    messageType={props.messageType} 
                    trackOpen={props.trackOpen} 
                    trackClicks={props.trackClicks} 
                />
            </>}

            <div className="column-section">
                {Object.keys(overviewSummary).length && <>
                    <SummaryColumn 
                        summaryinfo={overviewSummary.total_email_event_count} 
                        total={overviewSummary.first_step_total_recipients} 
                        totalsteps={overviewSummary.steps_count} 
                        messageType={props.messageType} 
                        trackOpen={props.trackOpen} 
                        trackClicks={props.trackClicks} 
                    />
                </>}
                
                {Object.keys(overviewSummary).length && <>
                    <RepliesColumn 
                        replyinfo={overviewSummary.total_email_event_count} 
                    />
                </>}

                {Object.keys(overviewSummary).length && <>
                    <LeadColumn 
                        leadinfo={overviewSummary.leads_status_count_percentage} 
                        leadstotal={overviewSummary.total_leads_count} 
                    />
                </>}
            </div>
        </div>}
    </>);
}

export default CampaignSummary;